import {round as _round} from 'lodash';
import type {CSSProperty, EnrichedAstNode} from '../../types';

type Modifier = (
    cssKey: CSSProperty | undefined,
    value: string | number,
    node: EnrichedAstNode,
    increment: number
) => number;

export const convertAutoToNumeric = (
    cssKey: CSSProperty | undefined,
    value: string | number,
    node: EnrichedAstNode
): number => {
    if (value === 'auto') {
        if (cssKey && ['width', 'maxWidth'].includes(cssKey)) {
            return _round(node.innerPosition.width, 0);
        }
        if (cssKey && ['height', 'maxHeight'].includes(cssKey)) {
            return _round(node.innerPosition.height, 0);
        }
        return 0;
    }
    return +value;
};

export const incrementCSSValue: Modifier = (cssKey, value, node, increment) => {
    if (typeof value === 'number') {
        return value + increment;
    }

    return convertAutoToNumeric(cssKey, value, node) + increment;
};

export const decrementCSSValue: Modifier = (cssKey, value, node, increment) => {
    if (typeof value === 'number') {
        return value - increment;
    }

    return convertAutoToNumeric(cssKey, value, node) - increment;
};
